import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BaseInput from "../base-input";
import Select from "../select";
import { countries } from "../../data";
import {
  setName,
  setSurname,
  setCountry,
  setPostcode,
  setEmail,
  setPhoneNumber
} from "../../store/actions";
import { lang, _ } from "../../model/utils";

const countriesEntries = countries[lang].entries.map(c => ({
  id: c,
  value: c
}));
const countriesDefault = countries[lang].default;

// taken from https://emailregex.com/
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const validateCap = str =>
  /^[0-9]+$/.test(str) ? "" : "Il CAP deve essere composto solo di numeri";
const validatePhoneNumber = str =>
  /^[0-9 ]+$/.test(str)
    ? ""
    : "Il numero di telefono deve essere composto solo di numeri o spazi";
const validateEmail = str => (emailRegex.test(str) ? "" : "Email non valida");

const mapStateToProps = ({
  name,
  nameError,
  surname,
  surnameError,
  country,
  countryError,
  postcode,
  postcodeError,
  email,
  emailError,
  phoneNumber,
  phoneNumberError
}) => ({
  name,
  nameError,
  surname,
  surnameError,
  country,
  countryError,
  postcode,
  postcodeError,
  email,
  emailError,
  phoneNumber,
  phoneNumberError
});

const mapDispatchToProps = dispatch => ({
  setName: value => dispatch(setName(value)),
  setSurname: value => dispatch(setSurname(value)),
  setCountry: value => dispatch(setCountry(value)),
  setPostcode: value => dispatch(setPostcode(value)),
  setEmail: value => dispatch(setEmail(value)),
  setPhoneNumber: value => dispatch(setPhoneNumber(value))
});

const BasePersonalDataForm = ({
  compact,
  name,
  nameError,
  surname,
  surnameError,
  country,
  countryError,
  postcode,
  postcodeError,
  email,
  emailError,
  phoneNumber,
  phoneNumberError,
  setName,
  setSurname,
  setCountry,
  setPostcode,
  setEmail,
  setPhoneNumber
}) => {
  // set default country value at startup
  React.useEffect(() => {
    setCountry(countriesDefault);
  }, [setCountry]);

  const firstColumnLayoutClasses = compact
    ? "col-lg-3 col-sm-6"
    : "col-sm-6 col-lg-4";
  const secondColumnLayoutClasses = compact
    ? "col-lg-3 col-sm-6"
    : "col-sm-6 col-lg-4 offset-lg-1";

  return (
    <>
      <div className="row">
        <div className={firstColumnLayoutClasses}>
          <BaseInput
            fieldName="name"
            placeholder={_.name}
            value={name}
            setValue={setName}
            error={nameError || ""}
          />
        </div>
        <div className={secondColumnLayoutClasses}>
          <BaseInput
            fieldName="surname"
            placeholder={_.surname}
            value={surname}
            setValue={setSurname}
            error={surnameError || ""}
          />
        </div>
        {!compact && (
          <>
            <div className={firstColumnLayoutClasses}>
              <Select
                fieldName="country"
                entries={countriesEntries}
                id={country}
                setId={setCountry}
                error={countryError || ""}
              />
            </div>
            <div className={secondColumnLayoutClasses}>
              <BaseInput
                fieldName="postcode"
                placeholder={_.postcode}
                validator={validateCap}
                value={postcode}
                setValue={setPostcode}
                error={postcodeError || ""}
              />
            </div>
          </>
        )}
        <div className={firstColumnLayoutClasses}>
          <BaseInput
            fieldName="email"
            placeholder={_.email}
            validator={validateEmail}
            value={email}
            setValue={setEmail}
            error={emailError || ""}
          />
        </div>
        <div className={secondColumnLayoutClasses}>
          <BaseInput
            fieldName="phoneNumber"
            placeholder={_.phoneNumber}
            validator={validatePhoneNumber}
            value={phoneNumber}
            setValue={setPhoneNumber}
            error={phoneNumberError || ""}
          />
        </div>
      </div>
    </>
  );
};

BasePersonalDataForm.propTypes = {
  compact: PropTypes.bool,
  name: PropTypes.string,
  surname: PropTypes.string,
  country: PropTypes.string,
  postcode: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  nameError: PropTypes.string,
  surnameError: PropTypes.string,
  countryError: PropTypes.string,
  postcodeError: PropTypes.string,
  emailError: PropTypes.string,
  phoneNumberError: PropTypes.string,
  setName: PropTypes.func,
  setSurname: PropTypes.func,
  setCountry: PropTypes.func,
  setPostcode: PropTypes.func,
  setEmail: PropTypes.func,
  setPhoneNumber: PropTypes.func
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BasePersonalDataForm);
